import { render, staticRenderFns } from "./CardAdress.vue?vue&type=template&id=526b5604&scoped=true&"
import script from "./CardAdress.vue?vue&type=script&lang=js&"
export * from "./CardAdress.vue?vue&type=script&lang=js&"
import style0 from "./CardAdress.vue?vue&type=style&index=0&id=526b5604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b5604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526b5604')) {
      api.createRecord('526b5604', component.options)
    } else {
      api.reload('526b5604', component.options)
    }
    module.hot.accept("./CardAdress.vue?vue&type=template&id=526b5604&scoped=true&", function () {
      api.rerender('526b5604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/CardAdress.vue"
export default component.exports